var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eventBrowser" },
    [
      _vm.error
        ? _c("div", { staticClass: "error" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.error) + "\n\t\t"),
            _c("div", { staticClass: "tryAgain" }, [
              _c("input", {
                attrs: { type: "button", value: "Try Again" },
                on: { click: _vm.loadEvents }
              })
            ])
          ])
        : _vm.events
        ? _c(
            "div",
            {
              staticClass: "eventListWrapper",
              on: {
                contextmenu: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.onContextmenu($event)
                }
              }
            },
            [
              _c("div", { staticClass: "eventListHeading" }, [
                _c("div", { staticClass: "path" }, [_vm._v(_vm._s(_vm.path))]),
                _vm._v(" "),
                _c("div", { staticClass: "eventTotals" }, [
                  _vm.newEvents > 0
                    ? _c(
                        "a",
                        {
                          staticClass: "newEvents",
                          attrs: {
                            title: "click to scroll to top",
                            role: "button",
                            tabindex: "0"
                          },
                          on: {
                            click: _vm.scrollToTop,
                            keypress: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.scrollToTop($event)
                            }
                          }
                        },
                        [_vm._v("^ " + _vm._s(_vm.newEvents) + " new ^")]
                      )
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.selectedEventIdsArray.length) +
                      "/" +
                      _vm._s(_vm.eventCount)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("RecycleScroller", {
                ref: "eventScroller",
                staticClass: "eventList",
                attrs: {
                  items: _vm.events,
                  "item-size": _vm.eventItemSize,
                  "key-field": "EventId",
                  emitUpdate: true
                },
                on: { update: _vm.eventScrollerUpdated },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("EventNode", {
                          attrs: {
                            projectName: _vm.projectName,
                            event: item,
                            selected: _vm.isEventSelected(item),
                            selectionState: _vm.selectionState,
                            selectedEventIdsArray: _vm.selectedEventIdsArray
                          },
                          on: {
                            menu: _vm.onMenu,
                            navUp: _vm.onNavUp,
                            navDown: _vm.onNavDown
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.loading
                ? _c("div", { staticClass: "loadingOverlay" }, [
                    _c(
                      "div",
                      { staticClass: "loading" },
                      [_c("ScaleLoader"), _vm._v(" Updating…")],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _c("div", [
            _vm._v("\n\t\tEvents not found.\n\t\t"),
            _c("div", { staticClass: "tryAgain" }, [
              _c("input", {
                attrs: { type: "button", value: "Try Again" },
                on: { click: _vm.loadEvents }
              })
            ])
          ]),
      _vm._v(" "),
      _c("vue-context", {
        ref: "menu",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(event) {
              return [
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: event.data,
                        expression: "event.data"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.beginMoveEvent(event.data)
                          }
                        }
                      },
                      [_vm._v("Move")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: event.data,
                        expression: "event.data"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.changeEventColor(event.data)
                          }
                        }
                      },
                      [_vm._v("Change Color")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: event.data,
                        expression: "event.data"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.deleteEvent(event.data)
                          }
                        }
                      },
                      [_vm._v("Delete")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: event.data && event.data.Read,
                        expression: "event.data && event.data.Read"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.markRead(event.data, false)
                          }
                        }
                      },
                      [_vm._v("Mark as unread")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: event.data && !event.data.Read,
                        expression: "event.data && !event.data.Read"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.markRead(event.data, true)
                          }
                        }
                      },
                      [_vm._v("Mark as read")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: event.data,
                        expression: "event.data"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.copyEventToProject(event.data)
                          }
                        }
                      },
                      [_vm._v("Copy to other project")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.nextUndo
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.undo()
                            }
                          }
                        },
                        [_vm._v("Undo " + _vm._s(_vm.nextUndo.description))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.nextRedo
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.redo()
                            }
                          }
                        },
                        [_vm._v("Redo " + _vm._s(_vm.nextRedo.description))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.nextUndo && !_vm.nextRedo && !event.data
                  ? _c("li", [
                      _c("span", { staticClass: "menuComment" }, [
                        _vm._v("no context menu items")
                      ])
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }